import { ReactComponent as CloseIcon } from "./close-icon.svg";

export const NotificationCloseIcon = ({ onClick }: NotificationCloseIconProps) => {
    return <CloseIcon className="notification-close-icon" onClick={onClick} title="Close Notification" />;
};

interface NotificationCloseIconProps {
    onClick: React.MouseEventHandler<SVGSVGElement>;
}
